import React from 'react';

const Assessment: React.FC = () => {
  return (
    <div className="page assessment">
      <div className="container">
        <div className="hero-section">
          <h1>DevOps Assessment Services</h1>
          <p className="hero-description">
            Comprehensive evaluation of your current DevOps maturity, infrastructure setup, 
            and development processes with actionable insights and improvement roadmaps.
          </p>
        </div>

        <section className="coming-soon-section">
          <div className="coming-soon-card">
            <div className="coming-soon-icon">
              <i className="fa-solid fa-chart-line"></i>
            </div>
            <h2>Coming Soon</h2>
            <p>
              Detailed assessment services are currently under development. This page will include 
              comprehensive information about our DevOps maturity assessments, infrastructure evaluations, 
              and process improvement recommendations.
            </p>
            <a href="/contact" className="contact-btn">Contact for Early Access</a>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Assessment;